// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"UniversitiesSelector_checkBox__x9FXq","appearance":"UniversitiesSelector_appearance__wLU4R","disappearance":"UniversitiesSelector_disappearance__1z3gC"};